import React, { useState } from 'react';
import './ServiceGuide.css';
import { Link } from 'react-router-dom';
import { objectives } from '../Data/ServiceObjectives';
import { sections } from '../Data/ObjectiveSections';



function ServiceGuide() {

            const [currentStep, setCurrentStep] = useState('start');
            const [selectedObjective, setSelectedObjective] = useState([null]);
            const [selectedServices, setSelectedServices] = useState([]);
            const [coreService, setCoreService] = useState(null);

            const toggleService = (serviceId, serviceName) => {
                setSelectedServices(prev => {
                    const index = prev.findIndex(s => s.id === serviceId);
                    if (index > -1) {
                        return prev.filter(s => s.id !== serviceId);
                    } else {
                        return [...prev, { id: serviceId, name: serviceName }];
                    }
                });
            };
 const selectObjective = (id) => {
                setSelectedObjective(id);
                setCoreService(sections[id].coreService.name);
                setSelectedServices([]);
                setCurrentStep('section');
            };

            const goToStart = () => {
                setCurrentStep('start');
                setSelectedObjective(null);
                setSelectedServices([]);
                setCoreService(null);
            };

            const goToSummary = () => {
                setCurrentStep('summary');
            };

            // Progress indicator component
            const ProgressIndicator = ({ step }) => {
                const steps = [1, 2, 3];
                return (
                    <div className="flex justify-items-center gap-2 w-fit">
                        {steps.map((s, i) => (
                            <div key={s} className="flex items-center">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300 ${
                                    s <= step 
                                        ? 'bg-white text-slate-900' 
                                        : 'bg-white/10 text-white/40'
                                }`}>
                                    {s < step ? (
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"/>
                                        </svg>
                                    ) : s}
                                </div>
                                {i < steps.length - 1 && (
                                    <div className={`w-12 h-0.5 mx-2 transition-all duration-300 ${
                                        s < step ? 'bg-white' : 'bg-white/10'
                                    }`}></div>
                                )}
                            </div>
                        ))}
                    </div>
                );
            };

            // Start Step
            if (currentStep === 'start') {
                return (
                    <section id="services" className="bg-slate-950 py-32 relative overflow-hidden">
                        {/* Gradient orbs */}
                        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-indigo-600/20 rounded-full blur-[128px] -translate-y-1/2"></div>
                        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-violet-600/20 rounded-full blur-[100px] translate-y-1/2"></div>
                        
                        <div className="max-w-5xl mx-auto px-8 relative z-10">
                            <header className="text-center mb-16">
                                <div className="flex justify-center mb-8">
                                    <ProgressIndicator step={1} />
                                </div>
                                <h2 className="text-4xl md:text-6xl font-bold mb-6 text-white tracking-tight">
                                    Find The Right Service
                                </h2>
                                <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
                                    Solutions come in all shapes and sizes, what's your mission'?
                                </p>
                            </header>

                            <div className="grid gap-4 md:grid-cols-2">
                                {objectives.map((obj, index) => (
                                    <button 
                                        key={obj.id}
                                        onClick={() => selectObjective(obj.id)}
                                        className="service-card group relative rounded-2xl p-8 text-left glass-effect border border-white/10 hover:border-white/25 transition-all duration-300"
                                    >
                                        {/* Hover gradient */}
                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-indigo-500/0 to-violet-500/0 group-hover:from-indigo-500/10 group-hover:to-violet-500/5 transition-all duration-300"></div>
                                        
                                        {/* Left accent line */}
                                        <div className="absolute left-0 top-6 bottom-6 w-0.5 bg-gradient-to-b from-indigo-400 to-violet-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        
                                        {/* ID badge */}
                                        <div className="absolute top-6 right-6 w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-500 font-semibold text-sm group-hover:bg-white/10 group-hover:text-white transition-all duration-300">
                                            {obj.id}
                                        </div>
                                        
                                        <div className="relative z-10 pr-14">
                                            <h4 className="text-xl font-semibold mb-2 text-white leading-snug">{obj.title}</h4>
                                            <p className="text-sm text-slate-500 mb-6 leading-relaxed">{obj.subtitle}</p>
                                            <div className="flex items-center gap-2 text-sm font-medium text-slate-500 group-hover:text-indigo-400 transition-colors duration-300">
                                                <span>Explore</span>
                                                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </section>
                );
            }

            // Section Step
            if (currentStep === 'section') {
                const section = sections[selectedObjective];
                const objective = objectives.find(o => o.id === selectedObjective);

                return (
                    <section id="services" className="bg-slate-950 py-32 relative overflow-hidden">
                        <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-indigo-600/15 rounded-full blur-[120px]"></div>
                        
                        <div className="max-w-4xl mx-auto px-8 fade-in relative z-10">
                            <header className="mb-12">
                                <button onClick={goToStart} className="group inline-flex items-center gap-2 text-sm font-medium mb-8 text-slate-500 hover:text-white transition-colors duration-200">
                                    <svg className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18"/>
                                    </svg>
                                    Back
                                </button>
                                
                                <div className="flex items-center gap-5 mb-8">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-indigo-500/25">
                                        {selectedObjective}
                                    </div>
                                    <ProgressIndicator step={2} />
                                </div>
                                
                                <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-3">{section.title}</h2>
                                <p className="text-slate-500">{objective.subtitle}</p>
                            </header>

                            <div className="space-y-10">
                                {/* Core Service Card */}
                                <div className="rounded-2xl p-8 relative overflow-hidden bg-gradient-to-br from-indigo-500/15 to-violet-500/5 border border-indigo-500/20">
                                    <div className="absolute top-0 right-0 w-48 h-48 bg-indigo-500/10 rounded-full blur-3xl"></div>
                                    <div className="relative z-10">
                                        <div className="flex items-center gap-3 mb-5">
                                            <div className="w-8 h-8 rounded-lg bg-indigo-500 flex items-center justify-center">
                                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"/>
                                                </svg>
                                            </div>
                                            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-400">Included</span>
                                        </div>
                                        <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">{section.coreService.name}</h3>
                                        <p className="text-slate-400 leading-relaxed">{section.coreService.description}</p>
                                    </div>
                                </div>

                                {/* Options */}
                                <div>
                                    <h3 className="text-xs font-semibold uppercase tracking-[0.2em] mb-5 text-slate-500">{section.prompt}</h3>
                                    <div className="grid gap-3">
                                        {section.options.map(opt => {
                                            const isSelected = selectedServices.some(s => s.id === opt.id);
                                            return (
                                                <button
                                                    key={opt.id}
                                                    onClick={() => toggleService(opt.id, opt.service)}
                                                    className={`group flex items-center gap-5 rounded-xl p-5 text-left transition-all duration-200 ${
                                                        isSelected 
                                                            ? 'bg-indigo-500/15 border border-indigo-500/40' 
                                                            : 'glass-effect border border-white/10 hover:border-white/20'
                                                    }`}
                                                >
                                                    <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                                                        isSelected 
                                                            ? 'bg-indigo-500' 
                                                            : 'border-2 border-slate-600 group-hover:border-slate-500'
                                                    }`}>
                                                        {isSelected && (
                                                            <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"/>
                                                            </svg>
                                                        )}
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <p className="text-sm text-slate-500 mb-1">{opt.trigger}</p>
                                                        <p className={`font-semibold transition-colors ${isSelected ? 'text-indigo-400' : 'text-white'}`}>{opt.service}</p>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Secondary Options */}
                                {section.secondaryOptions && (
                                    <div>
                                        <h3 className="text-xs font-semibold uppercase tracking-[0.2em] mb-5 text-slate-500">{section.secondaryPrompt}</h3>
                                        <div className="grid gap-3">
                                            {section.secondaryOptions.map(opt => {
                                                const isSelected = selectedServices.some(s => s.id === opt.id);
                                                return (
                                                    <button
                                                        key={opt.id}
                                                        onClick={() => toggleService(opt.id, opt.service)}
                                                        className={`group flex items-center gap-5 rounded-xl p-5 text-left transition-all duration-200 ${
                                                            isSelected 
                                                                ? 'bg-indigo-500/15 border border-indigo-500/40' 
                                                                : 'glass-effect border border-white/10 hover:border-white/20'
                                                        }`}
                                                    >
                                                        <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                                                            isSelected 
                                                                ? 'bg-indigo-500' 
                                                                : 'border-2 border-slate-600 group-hover:border-slate-500'
                                                        }`}>
                                                            {isSelected && (
                                                                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"/>
                                                                </svg>
                                                            )}
                                                        </div>
                                                        <div className="flex-1 min-w-0">
                                                            <p className="text-sm text-slate-500 mb-1">{opt.trigger}</p>
                                                            <p className={`font-semibold transition-colors ${isSelected ? 'text-indigo-400' : 'text-white'}`}>{opt.service}</p>
                                                        </div>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Continue */}
                                <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                                    <p className="text-sm text-slate-500 order-2 sm:order-1">
                                        {selectedServices.length === 0 
                                            ? 'No additional services selected' 
                                            : `${selectedServices.length} additional service${selectedServices.length > 1 ? 's' : ''} selected`
                                        }
                                    </p>
                                    <button 
                                        onClick={goToSummary}
                                        className="order-1 sm:order-2 w-full sm:w-auto group inline-flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-semibold text-white bg-gradient-to-r from-indigo-500 to-violet-600 hover:from-indigo-400 hover:to-violet-500 transition-all duration-300 shadow-lg shadow-indigo-500/25 hover:shadow-indigo-500/40"
                                    >
                                        <span>Continue</span>
                                        <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }

            // Summary Step
            if (currentStep === 'summary') {
                const section = sections[selectedObjective];
                const objective = objectives.find(o => o.id === selectedObjective);
                const totalServices = 1 + selectedServices.length;

                return (
                    <section id="services" className="bg-slate-950 py-32 relative overflow-hidden">
                        <div className="absolute top-1/3 left-1/4 w-[500px] h-[500px] bg-emerald-600/15 rounded-full blur-[120px]"></div>
                        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-indigo-600/10 rounded-full blur-[100px]"></div>
                        
                        <div className="max-w-4xl mx-auto px-8 fade-in relative z-10">
                            <header className="mb-12">
                                <button onClick={() => setCurrentStep('section')} className="group inline-flex items-center gap-2 text-sm font-medium mb-8 text-slate-500 hover:text-white transition-colors duration-200">
                                    <svg className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18"/>
                                    </svg>
                                    Edit selections
                                </button>
                                
                                <div className="flex items-center gap-5 mb-8">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg shadow-emerald-500/25">
                                        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                                        </svg>
                                    </div>
                                    <ProgressIndicator step={3} />
                                </div>
                                
                                <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-3">Your Package</h2>
                                <p className="text-slate-500">{objective.title}</p>
                            </header>

                            <div className="space-y-8">
                                {/* Stats */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="rounded-2xl p-6 glass-effect border border-white/10">
                                        <p className="text-xs text-slate-500 mb-2 uppercase tracking-[0.2em]">Total Services</p>
                                        <p className="text-4xl font-bold text-white">{totalServices}</p>
                                    </div>
                                    <div className="rounded-2xl p-6 glass-effect border border-white/10">
                                        <p className="text-xs text-slate-500 mb-2 uppercase tracking-[0.2em]">Category</p>
                                        <p className="text-xl font-semibold text-white">{section.title}</p>
                                    </div>
                                </div>

                                {/* Services List */}
                                <div className="rounded-2xl overflow-hidden glass-effect border border-white/10">
                                    {/* Core Service */}
                                    <div className="p-6 border-b border-white/10 bg-gradient-to-r from-indigo-500/10 to-transparent">
                                        <div className="flex items-center gap-4">
                                            <div className="w-10 h-10 rounded-xl bg-indigo-500 flex items-center justify-center flex-shrink-0">
                                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"/>
                                                </svg>
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <p className="text-xs text-indigo-400 uppercase tracking-[0.2em] mb-1">Core Service</p>
                                                <p className="font-semibold text-white text-lg">{coreService}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Additional Services */}
                                    {selectedServices.length > 0 ? (
                                        <div className="divide-y divide-white/5">
                                            {selectedServices.map((s, index) => (
                                                <div key={s.id} className="p-6 flex items-center gap-4">
                                                    <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0 text-slate-400 font-medium border border-white/10">
                                                        {String(index + 1).padStart(2, '0')}
                                                    </div>
                                                    <span className="font-medium text-white">{s.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="p-10 text-center">
                                            <p className="text-slate-500 mb-4">No additional services selected</p>
                                            <button onClick={() => setCurrentStep('section')} className="text-sm font-medium text-indigo-400 hover:text-indigo-300 transition-colors duration-200">
                                                Add more services
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                                    <button 
                                        onClick={goToStart}
                                        className="group flex-1 inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl font-semibold glass-effect border border-white/10 text-white hover:bg-white/10 transition-all duration-200"
                                    >
                                        <svg className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                                        </svg>
                                        Start Over
                                    </button>
                                    <button className="group flex-1 inline-flex items-center justify-center gap-3 px-6 py-4 rounded-xl font-semibold text-white bg-gradient-to-r from-indigo-500 to-violet-600 hover:from-indigo-400 hover:to-violet-500 transition-all duration-300 shadow-lg shadow-indigo-500/25 hover:shadow-indigo-500/40">
                                        <Link to="https://bambootradesllc.hbportal.co/public/projecthelp" target="_blank" rel="noopener noreferrer">Request Consultation</Link>
                                        {/* <span>Request Consultation</span> */}
                                        <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }

            return null;
        };

export default ServiceGuide;